import { useLocalStorageState } from 'ahooks';
import { expandAliasPermissions, hasPermission as matchPermission } from '@/utils';

/**
 * Types
 */
type Props = {
    children: React.ReactNode;
    permission: string;
};

const Permission: React.FC<Props> = ({ children, permission }) => {
    const [permissions] = useLocalStorageState<string[]>('permissions', {
        defaultValue: [],
        listenStorageChange: true,
    });

    const normalizedPermissions = expandAliasPermissions(permissions || []);

    if (matchPermission(normalizedPermissions, permission)) {
        return children;
    }

    return null;
};

export const useAccess: () => (permission: string) => boolean | undefined = () => {
    const [permissions] = useLocalStorageState<string[]>('permissions', {
        defaultValue: [],
        listenStorageChange: true,
    });

    const normalizedPermissions = expandAliasPermissions(permissions || []);

    return (permission: string) => {
        return matchPermission(normalizedPermissions, permission);
    };
};

export default Permission;
